var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegulatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.9999L5.93217 9.99994H8V16.9999H6ZM11 16.9999V9.99994H13V16.9999H11ZM3 8.99994V6.99994L12.2998 1.60278L21 6.99994V8.99994H3ZM7 6.99994H17L12.2998 3.96602L7 6.99994ZM3 20.0273V17.9704H14.2691C14.2983 18.233 14.3348 18.5539 14.3786 18.9332C14.4223 19.3125 14.5171 19.6772 14.663 20.0273H3ZM16 12.9999V9.99994H18V11.9999L16 12.9999ZM19.302 22.4999C18.2371 22.2374 17.3545 21.6247 16.6543 20.6619C15.954 19.6991 15.6039 18.6269 15.6039 17.4452V15.1039L19.302 13.2658L23 15.1039V17.4452C23 18.6269 22.6499 19.6991 21.9497 20.6619C21.2495 21.6247 20.3669 22.2374 19.302 22.4999ZM18.8206 19.6553L22.081 16.3949L21.4464 15.7603L18.8206 18.408L17.3326 16.9201L16.7199 17.5328L18.8206 19.6553Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatory);
export default __webpack_public_path__ + "static/media/regulatory.4b59d9d3.svg";
export { ForwardRef as ReactComponent };